// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { pt } from 'vuetify/locale';

import { DarkTheme } from '@/theme/DarkTheme';
import { LightTheme } from '@/theme/LightTheme';

const vuetify = createVuetify({
  locale: {
    locale: 'pt',
    messages: { pt },
  },
  theme: {
    defaultTheme: 'DarkTheme',
    themes: {
      LightTheme,
      DarkTheme,
    },
  },
});

export default vuetify;
